module.exports = __webpack_public_path__ + "static/media/press.fd220d89.png";